const convertToPercentage = (value) => (value !== null ? value * 100 : null);

export default convertToPercentage;
